module.exports = __webpack_public_path__ + "images/next-steps.273a20679b8a241d882ce26dd71a9248.png";